import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from './metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FunctionAdapterClass;
function FunctionAdapter() {
  if (FunctionAdapterClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'FunctionAdapter');
    FunctionAdapterClass = $;
  }
  return FunctionAdapterClass;
}
//region block: exports
export {
  FunctionAdapter as FunctionAdapter3lcrrz3moet5b,
};
//endregion

//# sourceMappingURL=FunctionAdapter.mjs.map
